// 域名映射(跳转地址)
export const jumplink = state => state.jumplink
// 登录人信息
export const userInfo = state => state.userInfo
// 个人中心信息
export const ownerInfo = state => state.ownerInfo
// 是否是当前登录人
export const owner = state => state.owner
// 主题图
export const themeImg = state => state.themeImg
// 登录页配置项
export const loginConfig = state => state.loginConfig
// 登录页按钮配置样式
export const loginBtnStyle = state => {
  if (state.loginConfig && state.loginConfig.buttonColor) {
    return {
      backgroundColor: state.loginConfig.buttonColor,
      borderColor: state.loginConfig.buttonColor
    }
  }
  return {}
}
// 登录页logo位置配置
export const logoPositionConfig = state => {
  // 默认1 左对齐
  const position = state.loginConfig.logoPosition || '1'
  const logoPositionEnum = {
    1: 'logo-left',
    2: 'logo-center',
    3: 'logo-right'
  }
  return logoPositionEnum[position]
}



// WEBPACK FOOTER //
// ./src/store/getters.js